import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {filter, Observable, Subscription, take} from "rxjs";
import {ReportService} from "../../../services/report.service";
import {PopupService} from "../../../services/popup.service";
import {Store} from "@ngrx/store";
import {SearchState} from "../../../state/search/search.reducer";
import { selectEventStatusesBySearchId } from "../../../state/search/search.selectors";
import {PulseLoadingComponent} from "../pulse-loading/pulse-loading.component";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-report-loader',
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    ReactiveFormsModule,
    NgForOf,
    PulseLoadingComponent
  ],
  templateUrl: './report-loader.component.html',
  styleUrl: './report-loader.component.scss'
})
export class ReportLoaderComponent {

  @Input() isVisible: boolean = false;
  @Input() searchId: number; // Input to fetch event statuses
  @Output() modalClosed: EventEmitter<void> = new EventEmitter();

  form: FormGroup;
  loading$: Observable<boolean>;
  dataList$: Observable<{ name: string; status: string }[]>;

  constructor(
    public formBuilder: FormBuilder,
    private store: Store<{ report: SearchState }>
  ) {
    this.form = formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.loading$ = this.store.select(state => state.report.isLoading);
  }

  ngOnInit(): void {
    // Fetch event statuses and map to dataList format
    // console.log('this.searchId', this.searchId)
    this.dataList$ = this.store.select(selectEventStatusesBySearchId(this.searchId)).pipe(
      map(eventStatuses => {
        console.log('Event statuses:', eventStatuses);
        return [
          { name: 'Company Revenue', status: eventStatuses.companyRevenue ? 'completed' : 'loading' },
          { name: 'Company Profit', status: eventStatuses.companyProfit ? 'completed' : 'loading' },
          { name: 'Company Funding', status: eventStatuses.companyFunding ? 'completed' : 'loading' },
          { name: 'Company Employees', status: eventStatuses.companyEmployees ? 'completed' : 'loading' },
        ];
      })
    );

  }

  closeModal() {
    this.isVisible = false;
    this.modalClosed.emit(); // Notify the parent component that the modal has been closed
    this.form.reset();
  }

}
